import React, { useState, useEffect, useMemo } from 'react';
import MatchListing from './MatchListing';
import { MATCH_STATUS, type Match } from '../../types/match';
import { useAgentReviews } from '../../hooks/useAgentReview';

interface RejectedAgentReviewListingProps {
  onDataChange?: (count: number) => void;
  startDate?: Date | null;
  endDate?: Date | null;
  search: string;
}

const RejectedAgentReviewListing = ({
  startDate,
  endDate,
  search,
}: RejectedAgentReviewListingProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(15);

  const {
    data: matches,
    isFetching,
    refetch: fetchAgentReviews,
  } = useAgentReviews({
    page: currentPage,
    limit,
    status: MATCH_STATUS.REJECTED,
    start_date: startDate?.toISOString() ?? undefined,
    end_date: endDate?.toISOString() ?? undefined,
  });

  const filteredMatches = useMemo(() => {
    if (search.length > 2) {
      return matches?.result.items.filter((match: Match) =>
        match.other_user.name.toLowerCase().includes(search.toLowerCase())
      );
    }
    return matches?.result.items;
  }, [search, matches]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    if (endDate && currentPage !== 1) {
      setCurrentPage(1);
    } else {
      fetchAgentReviews();
    }
  }, [endDate, currentPage]);

  return (
    <MatchListing
      matches={filteredMatches}
      currentPage={currentPage}
      totalPages={matches?.result.meta.pages ?? 0}
      totalItems={matches?.result.meta.total ?? 0}
      limit={limit}
      onPageChange={handlePageChange}
      loading={isFetching}
    />
  );
};

export default RejectedAgentReviewListing;
